// extracted by mini-css-extract-plugin
export default {"pin":"LhUTdvLgRwwM0s9QhPiN"};